import {AllergySeverity} from '../constant';

export const SEVERITY_OPTIONS = [
  {label: 'Low', value: AllergySeverity.Low},
  {label: 'Moderate', value: AllergySeverity.Moderate},
  {label: 'Severe', value: AllergySeverity.Severe},
];
